import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const PageHeading: React.FC = () => {
	return (
		<div className="container mb-10 pt-8">
			<Text variant="heading" size="x-large" as="h1" className="mb-6 capitalize">
				<Translate value="fe.pages.team.title" />
			</Text>
		</div>
	);
};
